module.exports = __webpack_public_path__ + "static/img/0410.4cf586a4.png";